<div class="export-report-dialog update-inspection-modal">
  <div class="export-report-dialog-header flex-between-center">
    <p class="m-0 font-bold">{{dialogTitle}} </p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="closeModal()"></i>
    </span>
  </div>

  <div class="export-report-dialog-body">
    <p class="font-gray-45 font-12">
      {{dialogDescription}}
    </p>
    <div class="update-inspections-scroll-container">
      <div class="row">
        <div class="col-6" *ngFor="let inspection of cannedInspections; let i=index">
          <div class="mb-2 export-col-check text-truncate" [ngClass]="{'inspection-update-delete': isDeleteDialog}">
            <span *ngIf="isDeleteDialog">
              {{i+1}}. {{ inspection.title}}
            </span>
            <app-checkbox *ngIf="!isDeleteDialog" [label]="inspection.title"
              (appChange)="handleCheckboxSelect($event, inspection._id)" [isChecked]="true">
            </app-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="export-report-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="closeModal()">Cancel</button>
    <button class="btn btn-primary btn-submit" (click)="onSubmit()">
      {{isDeleteDialog
      ? isOpeningFromUpdate ? 'Update' : 'Delete'
      : 'Save'}}
      <i class="fal fa-spinner rotate" *ngIf="processing"></i>
    </button>
  </div>
</div>